import { Button } from '@app/components/ui/button';
import Logo from '@cloud-ui/components/Logo';
import ThemeSelector from '@cloud-ui/components/ThemeSelector';
import type { ResolvedTheme, ThemePreference } from '@cloud-ui/hooks/useThemePreference';

import { Link as RouterLink } from 'react-router-dom';

interface AuthHeaderProps {
  themePreference: ThemePreference;
  systemTheme: ResolvedTheme;
  onThemePreferenceChange: (preference: ThemePreference) => void;
  showSignUpLink?: boolean;
  signUpLinkHref?: string;
  signUpLinkText?: string;
}

/**
 * Minimal header for authentication pages (login, register, etc.)
 * Displays logo on left, theme selector (and optional sign up link) on right.
 */
export default function AuthHeader({
  themePreference,
  systemTheme,
  onThemePreferenceChange,
  showSignUpLink = false,
  signUpLinkHref = '/register',
  signUpLinkText = 'Sign up',
}: AuthHeaderProps) {
  return (
    <header className="fixed top-0 z-[1] flex h-[var(--navigation-height)] w-full items-center justify-between border-b border-border bg-background px-6">
      <Logo />
      <div className="flex items-center gap-4">
        {showSignUpLink && (
          <Button asChild variant="outline" size="sm">
            <RouterLink to={signUpLinkHref}>{signUpLinkText}</RouterLink>
          </Button>
        )}
        <ThemeSelector
          themePreference={themePreference}
          systemTheme={systemTheme}
          onThemePreferenceChange={onThemePreferenceChange}
        />
      </div>
    </header>
  );
}
